<tcc-mono-dialog-layout
  [title]="'Selecteer een dier'"
  [displayBottomButtons]="true"
  [saveText]="'Ververs'"
  (onSave)="forceRefreshList()"
  [displaySearch]="true"
  [focusOnSearch]="!scannedIdentificationNumber"
  [displayBottomButtonsFixedAndTransparent]="true"
  (onSearch)="setQ($event)"
  [searchDebounce]="0"
  [searchInputType]="'number'"
>
  <ion-content>
    <div class="animals-dialog-skeleton" *ngIf="loading">
      <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
      <div class="skeleton-list-item" *ngFor="let _ of skeletonRows">
        <div class="skeleton-line skeleton-line-lg"></div>
        <div class="skeleton-line skeleton-line-sm"></div>
      </div>
    </div>
    <ng-container *ngIf="!loading">
    <ion-progress-bar *ngIf="processing" type="indeterminate" color="primary"></ion-progress-bar>
    <ng-container *ngIf="(toolbarData$ | async) as data">
    <div *ngIf="getUsedColors(data.colors)?.length" class="color-filter-bar">
      <div class="color-filter-dots" aria-label="Filter op kleur">
        <button
          type="button"
          class="color-dot color-dot-none"
          [class.selected]="(filterByColorValue$ | async) == null"
          (click)="setFilterByColorValue(null)"
          [attr.aria-pressed]="(filterByColorValue$ | async) == null"
          title="Alle"
        >
          <span class="color-count">{{ data.animals?.length ?? 0 }}</span>
        </button>
        <button
          *ngFor="let c of getUsedColors(data.colors)"
          type="button"
          class="color-dot"
          [style.background-color]="getMarkColorHex(c.value)"
          [class.selected]="(filterByColorValue$ | async) === c.value"
          (click)="setFilterByColorValue(c.value)"
          [attr.aria-pressed]="(filterByColorValue$ | async) === c.value"
          [attr.title]="getColorFilterTitle(c)"
        >
          <span class="color-count">{{ data.countsByColor?.[c.value] ?? 0 }}</span>
        </button>
      </div>
    </div>
    </ng-container>
    <tcc-mono-stacked-list
      #stackedList
      [items]="filteredAnimals$ | async"
      [listItems]="listItem"
      (itemClicked)="selectAnimal($event)"
      [compareSelectedBy]="'dierLevensnummer'"
      [itemSize]="scrollItemSize"
      [minBufferPx]="2400"
      [maxBufferPx]="3600"
      [infiniteScroll]="false"
      [trackBy]="trackByAnimal"
    >
      <ion-item slot="first-item" button (click)="addNewAnimal()">
        <ion-label> Het dier staat er niet tussen...</ion-label>
      </ion-item>
    </tcc-mono-stacked-list>
    </ng-container>
  </ion-content>
</tcc-mono-dialog-layout>
